<template>
  <ColumnChart
      :title="'Aylık Ciro Grafiği'"
      :description="'Ay bazlı ciro değişim grafiği'"
      :columnChartOptions="monthGiroDistributionDataChartOptions"
      :loading="monthGiroDistributionDataLoading"
  >
  </ColumnChart>
</template>

<script>

import ColumnChart from "@/components/shared/apex-charts/ColumnChart";
import {mapActions, mapState} from "vuex";
import {numberConverter} from "../../../../helpers";

export default {
  name: "AylikCiroGrafigi",
  components: {
    ColumnChart
  },
  props: {
    dashboardFilterCurrentCodeProp: {
      type: String,
      default: null
    },
    dashboardFilterSalesPersonCodeProp: {
      type: String,
      default: null
    },
    dashboardFilterReportDbNameProp: {
      type: String,
      default: null
    }
  },
  mounted() {
    this._fetchMonthGiroDistributionReport();
  },
  computed: {
    ...mapState("settings", ["erpSettings"]),
    ...mapState("auth", ["user"])
  },
  data() {
    return {
      monthGiroDistributionDataChartOptions: {
        series: [],
        chartOptions: {
          noData: {
            text: "Aradığınız Kriterde Aylık Ciro Grafiği Verisi Bulunamamıştır",
            align: "center",
            verticalAlign: "middle",
          },
          chart: {
            toolbar: {
              show: true,
            }
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '100%',
            },
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 4,
            colors: ['transparent']
          },
          colors: ['#34c38f', '#556ee6', '#ff9f43', '#f46a6a'],
          xaxis: {
            categories: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'],
            title: {
              text: 'Aylık Ciro Grafiği',
              style: {
                fontWeight: '800',
              },
            },
          },
          yaxis: {
            title: {
              text: 'Aylara Göre Dağılım',
              style: {
                fontWeight: '800',
              },
            },
            labels: {
              formatter: function (value) {
                return Math.round(value).toLocaleString();
              },
            },
          },
          grid: {
            borderColor: '#f1f1f1',
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val + " TRY"
              }
            }
          }
        }
      },
      monthGiroDistributionDataLoading: true,
    }
  },
  methods: {
    numberConverter,
    ...mapActions("dashboard", [
      "fetchMonthGiroDistributionReport"
    ]),
    _fetchMonthGiroDistributionReport() {
      this.monthGiroDistributionDataLoading = true;
      this.fetchMonthGiroDistributionReport({
        params: {
          userId: this.user.UserId,
          ...(!(this.dashboardFilterCurrentCodeProp === "" || this.dashboardFilterCurrentCodeProp == null)) && {currentCode: this.dashboardFilterCurrentCodeProp},
          ...(!(this.dashboardFilterSalesPersonCodeProp === "" || this.dashboardFilterSalesPersonCodeProp == null)) && {salesPersonCode: this.dashboardFilterSalesPersonCodeProp},
          ...(!(this.dashboardFilterReportDbNameProp === "" || this.dashboardFilterReportDbNameProp == null)) && {reportDbName: this.dashboardFilterReportDbNameProp}
        },
        body: {}
      }).then((result) => {
        if (result && result.data.success)
        {

          this.monthGiroDistributionDataChartOptions.series = this.erpSettings.netsisCurrencySale ? [
            {
              name: 'KDV Dahil',
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            },
            {
              name: 'KDV Hariç',
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            },
            {
              name: 'KDV Dahil Dövizli',
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            },
            {
              name: 'KDV Hariç Dövizli',
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            }
          ] : [
            {
              name: 'KDV Dahil',
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            },
            {
              name: 'KDV Hariç',
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            }
          ];

          let resultArray = result.data.data;
          let kdvDahilObject = this.monthGiroDistributionDataChartOptions.series.find(item => item.name === "KDV Dahil");
          let kdvHaricObject = this.monthGiroDistributionDataChartOptions.series.find(item => item.name === "KDV Hariç");
          let kdvDahilDovizliObject = this.monthGiroDistributionDataChartOptions.series.find(item => item.name === "KDV Dahil Dövizli");
          let kdvHaricDovizliObject = this.monthGiroDistributionDataChartOptions.series.find(item => item.name === "KDV Hariç Dövizli");

          for (let i = 0; i < resultArray.length; i++) {


            if (kdvDahilObject) {
              kdvDahilObject.data[(resultArray[i].sequence - 1)] = resultArray[i].vatIncludedPrice;
            }

            if (kdvHaricObject) {
              kdvHaricObject.data[(resultArray[i].sequence - 1)] = resultArray[i].vatExcludedPrice;
            }

            if (kdvDahilDovizliObject) {
              kdvDahilDovizliObject.data[(resultArray[i].sequence - 1)] = resultArray[i].vatIncludedCurrencyPrice;
            }

            if (kdvHaricDovizliObject) {
              kdvHaricDovizliObject.data[(resultArray[i].sequence - 1)] = resultArray[i].vatExcludedCurrencyPrice;
            }

          }
          this.monthGiroDistributionDataChartOptions.chartOptions.tooltip.y.formatter = (val) => {
            return this.numberConverter(val);
          }
        }else {
          this.monthGiroDistributionDataChartOptions.series= []
        }
        this.monthGiroDistributionDataLoading = false;
      }).catch(err => {
        err;
        this.monthGiroDistributionDataLoading = false;
      })
    },
  },
  watch: {
    dashboardFilterCurrentCodeProp(newVal) {
      newVal;
      this._fetchMonthGiroDistributionReport()
    },
    dashboardFilterSalesPersonCodeProp(newVal) {
      newVal;
      this._fetchMonthGiroDistributionReport()
    },
    dashboardFilterReportDbNameProp(newVal) {
      newVal;
      this._fetchMonthGiroDistributionReport()
    }
  }
}
</script>

<style scoped>

</style>